function encodeQueryData(data) {
  let ret = [];
  for (let d in data) {
    if (data[d]) {
      if (Array.isArray(data[d])) {
        for (let i in data[d]) {
          ret.push(encodeURIComponent(d) + '=' + encodeURIComponent(data[d][i]));
        }
      } else {
        ret.push(encodeURIComponent(d) + '=' + encodeURIComponent(data[d]));
      }
    }
  }
  return ret.join('&');
}

function decodeQueryData() {
  let query = location.search.substr(1);
  let result = {};
  query.split('&').forEach(function(part) {
    let [key, val] = part.split('=');
    val = decodeURIComponent(val);

    // if it looks like a number
    if (!isNaN(val)) {
      val = parseInt(val);
    }

    // already in result,
    // treat as array
    if (key in result && !Array.isArray(result[key])) {
      result[key] = [result[key]];
    }

    if (Array.isArray(result[key])) {
      result[key].push(val);
    } else {
      result[key] = val;
    }
  });
  return result;
}

export {encodeQueryData, decodeQueryData};



// WEBPACK FOOTER //
// ./res/front/static/js/util.js